// apply filters to the custom booking questions to distingush between adult ticket type and child ticket type questions

angular.module('westBerkshireEvents.ticketTypeQuestions').filter('wbAddressFilter', function () {
    return function (client) {

            let addressParts = [];

            if (client.address1) {
                addressParts.push(client.address1);
            }
            if (client.address2) {
                addressParts.push(client.address2);
            }
            if (client.address3) {
                addressParts.push(client.address3);
            }
            if (client.address4) {
                addressParts.push(client.address4);
            }
            if (client.address5) {
                addressParts.push(client.address5);
            }
            if (client.postcode) {
                addressParts.push(client.postcode);
            }

            var val = addressParts.join(', ');
            
        return val;
    };
});


// WEBPACK FOOTER //
// src/public/javascripts/custom-questions/use_my_details_address.filter.js